import React, { useState, useRef, useEffect } from "react";
import InvitCard from "../../asset/invt_card.jpg";
import InvitCardBlue from "../../asset/invt_card_blue.png";

import waiverCode from "../../asset/waiver.png";
import styles from "./invitationCard.module.css";
// import { postRequest } from "../../../util/request/request";
// import { authPost } from "../../../util/request/authPost";

import {
  Stack,
  Typography,
  TextField,
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  FormLabel,
  InputLabel,
  RadioGroup,
  Select,
  MenuItem,
  Button,
  Modal,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
// import { authPut } from "../../../util/request/authPut";

function convertTo12HourTimeCompact(time24) {
  const [hour, minute] = time24.split(":").map(Number);
  const period = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return minute === 0
    ? `${hour12} ${period}`
    : `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "90%",
  // bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const InvitationCardDownloader = (props) => {
  const canvasRef = useRef(null); // Reference to the canvas element
  const [image, setImage] = useState(InvitCard); // Store the loaded image
  const [cardOption, setCardOption] = useState("pink");
  const [detail, setDetail] = useState({
    celebrant: "",
    month: "",
    day: "",
    party_time: "",
    rsvp: "",
  });
  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  const drawImageWithText = (img, zoomLevel) => {
    const canvas = canvasRef.current;
    console.log(canvas);

    const ctx = canvas.getContext("2d");

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Set canvas dimensions to match the original image
    canvas.width = img.width;
    canvas.height = img.height;

    // Apply zoom scaling to display the image
    ctx.save(); // Save the current state
    ctx.scale(zoomLevel, zoomLevel);

    // Draw the image on the canvas

    ctx.drawImage(img, 0, 0, img.width, img.height);

    const code = new Image();
    code.src = waiverCode;
    code.onload = () => {
      ctx.drawImage(code, 68, 1432);
    };

    // Add text overlay
    ctx.font = "50px Arial";
    ctx.fillStyle = "purple";

    ctx.fillText(`${detail.celebrant}'s`, 600, 290);
    ctx.fillText(detail.month + " " + detail.day, 500, 1430); // Add text at (20, 50)
    ctx.fillText(
      detail.party_time,

      500,
      1505
    ); // Add text at (20, 50)
    ctx.fillText(detail.rsvp, 500, 1675); // Add text at (20, 50)
    // Add dynamic text (if provided)
    // if (text) {
    //   ctx.fillText(text, 100, 200);
    // }

    ctx.restore(); // Restore original state (no scaling applied for further operations)
  };

  const downloadImage = () => {
    const canvas = canvasRef.current;

    // Generate the image data from the canvas (with modifications)
    const imageData = canvas.toDataURL("image/png");

    // Create a link to download the image
    const link = document.createElement("a");
    link.href = imageData;
    link.download = "Invitation_Card.png";
    link.click();
  };
  console.log(detail);
  useEffect(() => {
    const img = new Image();
    img.src = cardOption === "pink" ? InvitCard : InvitCardBlue; // Replace with your image path
    img.onload = () => {
      setImage(img); // Store the loaded image
      drawImageWithText(img, 1); // Initial draw with default zoom
    };
  }, [detail, cardOption]);

  return (
    <Box>
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ bgcolor: "white", width: "100%", height: "100%" }}
      >
        <Box>
          <canvas ref={canvasRef} className={styles.canvas}></canvas>
        </Box>
        <Stack>
          <FormLabel id="demo-radio-buttons-group-label"></FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="pink"
            name="radio-buttons-group"
            onChange={(e) => {
              setCardOption(e.target.value);
            }}
          >
            <FormControlLabel
              value="pink"
              control={<Radio />}
              label="Candy Pink"
            />
            <FormControlLabel
              value="blue"
              control={<Radio />}
              label="Candy Blue"
            />
          </RadioGroup>
          <TextField
            variant="standard"
            label="Birthday boy/girl"
            value={detail.celebrant}
            onChange={(e) => {
              setDetail((prev) => ({
                ...prev,
                celebrant: e.target.value,
              }));
            }}
          ></TextField>
          <Stack
            direction="row"
            component="form"
            sx={{ width: "300px", mt: "10px" }}
          >
            <FormControl variant="standard" sx={{ minWidth: 80 }}>
              <InputLabel id="demo-simple-select-standard-label">
                Month
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={detail.month}
                onChange={(e) => {
                  setDetail((prev) => ({
                    ...prev,
                    month: e.target.value,
                  }));
                }}
                label="MM"
                required
                sx={{ width: "70px" }}
                name="birthDateMonth"
              >
                {[
                  ["Jan"],
                  ["Feb"],
                  ["Mar"],
                  ["Apr"],
                  ["May"],
                  ["Jun"],
                  ["Jul"],
                  ["Aug"],
                  ["Sep"],
                  ["Oct"],
                  ["Nov"],
                  ["Dec"],
                ].map((m) => (
                  <MenuItem key={m[0]} value={m[0]}>
                    {m[0]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="standard" sx={{ minWidth: 80 }}>
              <InputLabel id="demo-simple-select-standard-label">
                Day
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={detail.day}
                onChange={(e) => {
                  setDetail((prev) => ({
                    ...prev,
                    day: e.target.value,
                  }));
                }}
                label="DD"
                name="birthDateDay"
                required
                sx={{ width: "60px" }}
              >
                {days.map((day) => (
                  <MenuItem key={day} value={day < 10 ? "0" + day : day}>
                    {day}
                  </MenuItem>
                ))}

                {/* <MenuItem value={"01"}>{"01"}</MenuItem>
                  <MenuItem value={"02"}>02</MenuItem>
                  <MenuItem value={"03"}>03</MenuItem> */}
              </Select>
            </FormControl>
            <FormControl variant="standard" sx={{ minWidth: 80 }}>
              <InputLabel id="demo-simple-select-standard-label">
                Time
              </InputLabel>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={detail.party_time}
                onChange={(e) => {
                  setDetail((prev) => ({
                    ...prev,
                    party_time: e.target.value,
                  }));
                }}
                label="Time"
                required
                sx={{ width: "120px" }}
                name="birthDateMonth"
              >
                {[
                  ["10am - 12pm"],
                  ["1pm - 3pm"],
                  ["3:30pm - 5:30pm"],
                  ["4pm - 6pm"],
                  ["6pm - 8pm"],
                  ["7pm - 9pm"],
                  ["8:30pm - 10:30pm"],
                ].map((m) => (
                  <MenuItem key={m[0]} value={m[0]}>
                    {m[0]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <TextField
            variant="standard"
            label="RSVP"
            value={detail.rsvp}
            onChange={(e) => {
              setDetail((prev) => ({
                ...prev,
                rsvp: e.target.value,
              }));
            }}
          ></TextField>
        </Stack>

        <Stack direction="row" spacing={2}>
          <Button onClick={downloadImage} variant="contained">
            Download
          </Button>

          {/* <Button onClick={sendEmailInvitation} variant="contained">
              Email
            </Button> */}
        </Stack>
      </Stack>
    </Box>
  );
};

export default InvitationCardDownloader;
